import React, { useEffect } from "react";

const About = () => {
  useEffect(() => {
    document.title = "About — GitHub Finder";
  }, []);

  return (
    <div className="about-page fade-in">
      <h1>About</h1>
      <p>
        GitHub Finder lets you search for GitHub users and explore their
        profiles, repositories, and activity — all in one place.
      </p>
      <p className="version">v1.0.0</p>
    </div>
  );
};

export default About;
